import styles from './SearchTray.module.css';
import { usePersistentCategories } from '../../hooks/usePublishedContent';

export interface SuggestedCategoriesListProps {
  onSelect: (category: { id: string; name: string; section: string }) => void;
  limit?: number;
}

/**
 * Top-N main-branch categories shown as chips in the empty-query state.
 * Reuses the existing `usePersistentCategories` hook (no section filter).
 */
export function SuggestedCategoriesList({ onSelect, limit = 5 }: SuggestedCategoriesListProps) {
  const { data, isLoading } = usePersistentCategories();
  if (isLoading || !data || data.length === 0) return null;
  const top = data.slice(0, limit);
  return (
    <div className={styles.group}>
      <div className={styles.groupLabel}>Suggested</div>
      <div className={styles.chipsRow}>
        {top.map((c) => (
          <button
            key={c.id}
            type="button"
            className={styles.chip}
            onClick={() => onSelect({ id: c.id, name: c.name, section: c.section })}
          >
            {c.name}
          </button>
        ))}
      </div>
    </div>
  );
}
